<h1>🀄️{{'SETTINGS'|translate}}</h1>
<div class="settings-content">
	<div class="settings">
		<p>{{'LANG'|translate}}</p>
		<div class="buttons">
			<form>
				<ul class="radio">
					<li><input type="radio" name="lang" id="lang0" value="auto" [(ngModel)]="app.settings.lang" (ngModelChange)="app.setLang()" /><label for="lang0">{{'LANG_AUTO'|translate}}</label></li>
					<li><input type="radio" name="lang" id="lang1" value="en" [(ngModel)]="app.settings.lang" (ngModelChange)="app.setLang()" /><label for="lang1">{{'LANG_EN'|translate}}</label></li>
					<li><input type="radio" name="lang" id="lang2" value="de" [(ngModel)]="app.settings.lang" (ngModelChange)="app.setLang()" /><label for="lang2">{{'LANG_DE'|translate}}</label></li>
				</ul>
			</form>
		</div>
		<p>{{'BEST_TIMES'|translate}}</p>
		<div>
			<button (click)="clearTimesClick()">{{'BEST_TIMES_CLEAR'|translate}}</button>
		</div>
	</div>
	<div class="settings">
		<p>{{'TILESET'|translate}}</p>
		<div class="buttons">
			<form>
				<ul class="radio">
					<li *ngFor="let imageset of sets; let i=index;"><input type="radio" name="imageset" id="imageset{{i}}" [value]="imageset.id" [(ngModel)]="app.settings.tileset"/><label for="imageset{{i}}">{{imageset.name}} <a target="_blank" rel="noopener" href="{{imageset.url}}">Source</a></label></li>
				</ul>
			</form>
		</div>
	</div>
	<div class="settings">
		<p>{{'BACKGROUND'|translate}}</p>
		<div class="buttons">
			<form>
				<ul class="radio">
					<li *ngFor="let back of backs; let i=index;"><input type="radio" name="back" id="back{{i}}" [value]="back.img" [(ngModel)]="app.settings.background"/><label for="back{{i}}">{{back.name}}</label></li>
				</ul>
			</form>
		</div>
	</div>
</div>
